// src/app/views/token/Token.tsx

'use client';
import React from 'react';
import styles from './Token.module.scss';
import TerminalHeader from '../terminal-header/TerminalHeader';

const Token: React.FC = () => {
  return (
    <div className={styles.token}>
      {/* Header */}
      <TerminalHeader />

      <div className={styles['token__content']}>
        {/* Title (reserved) */}
        <h2 className={styles['token__title']}></h2>

        {/* Introductory Paragraph */}
        <p className={styles['token__paragraph']}>
          {`> $CHADAI is the official deflationary reserve currency of Chads around the world and backed by a strategic reserve of 100% real, dank memes.`}
        </p>

        {/* Additional Details */}
        <p className={styles['token__paragraph']}>
          {`> Just as tokens in AI models represent units of information, each of the 420 million $CHADAI tokens symbolizes 1 million units in the Chad Language Model’s 420 trillion parameters.`}
        </p>

        {/* List Introduction */}
        <p className={styles['token__paragraph']}>{`$CHADAI is used to:`}</p>

        {/* Token Use Cases */}
        <ul className={styles['token__list']}>
          <li>
            <img
              src={`/icons/right-arrow.png`}
              alt={`arrow`}
              className={styles['token__list-icon']}
            />
            {` Fuel and grow the ChadAI ecosystem`}
          </li>
          <li>
            <img
              src={`/icons/right-arrow.png`}
              alt={`arrow`}
              className={styles['token__list-icon']}
            />
            {` Referral fee rewards for Chad Bot users`}
          </li>
          <li>
            <img
              src={`/icons/right-arrow.png`}
              alt={`arrow`}
              className={styles['token__list-icon']}
            />
            {` Incentives to train the Chad Language Model`}
          </li>
          <li>
            <img
              src={`/icons/right-arrow.png`}
              alt={`arrow`}
              className={styles['token__list-icon']}
            />
            {` Pay for trading fees including burning mechanisms`}
          </li>
          <li>
            <img
              src={`/icons/right-arrow.png`}
              alt={`arrow`}
              className={styles['token__list-icon']}
            />
            {` Premium features and subscriptions`}
          </li>
          <li>
            <img
              src={`/icons/right-arrow.png`}
              alt={`arrow`}
              className={styles['token__list-icon']}
            />
            {` Staking rewards for $CHADAI holders`}
          </li>
          <li>
            <img
              src={`/icons/right-arrow.png`}
              alt={`arrow`}
              className={styles['token__list-icon']}
            />
            {` Voting and treasury management`}
          </li>
        </ul>

        <p className={styles['token__paragraph']}>{`Chadpaper coming soon.`}</p>
      </div>
    </div>
  );
};

export default Token;
